import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import Clamp from 'react-multiline-clamp';
import NewsFeedDoc from '../commons/icons/NewsFeedDoc';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 94px;
  max-height: 94px;
`;

const ArticleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 58px;
  column-gap: 10px;
  height: 60px;
  padding: 18px 11px;
  border-radius: 6px;
  box-shadow: 0px 2px 5px 1px rgb(0 0 0 / 13%);
  -webkit-box-shadow: 0px 2px 5px 1px rgb(0 0 0 / 13%);
  -moz-box-shadow: 0px 2px 5px 1px rgb(0 0 0 / 13%);
`;

const ArticleImage = styled.div`
  width: 87px;
  height: 100%;
  min-width: 87px;
  max-height: 100%;
  img {
    object-fit: cover;
    object-position: center;
    width: 100%;
    height: 100%;
  }
`;

const ArticleInformation = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-between;
`;

const ArticleInformationTopSection = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 3px;
`;

const ArticleTitle = styled.span`
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 19px;
`;

const SvgIcon = styled(NewsFeedDoc)`
  width: 60px;
  height: 60px;
`;

const SvgIconContainer = styled.div`
  width: 87px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #C5E1DF;
 `;

const ArticleInformationBottomSection = styled.div`
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: #919191;
  display: flex;
  column-gap: 8px;
  span {
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
  }
`;

const SuggestedArticleListItem = ({itemData}) => {
  const navigate = useNavigate();

  const onClickHandler = (id: any) => {
    navigate(`/newsfeed/read/${id}`);
  };

  const formattedDate = moment(itemData.timestamp).format('MMMM D, YYYY');
  const minutesToRead = Math.floor(itemData.readTime / 60);

  return (
    <Wrapper onClick={() => onClickHandler(itemData.id)}>
      <ArticleWrapper>
        <ArticleImage>
        {!itemData.media || itemData.media.endsWith('.pdf')
              ? <SvgIconContainer><SvgIcon /></SvgIconContainer>
              : <img src={itemData.media} />
            }
        </ArticleImage>
        <ArticleInformation>
          <ArticleInformationTopSection>
            <Clamp withTooltip={true} lines={2}>
              <ArticleTitle>{itemData.title}</ArticleTitle>
            </Clamp>
          </ArticleInformationTopSection>
          <ArticleInformationBottomSection>
            <span>{formattedDate}</span>
            <span>&#x2022;</span>
            <span>{minutesToRead} min read</span>
          </ArticleInformationBottomSection>
        </ArticleInformation>  
      </ArticleWrapper>
    </Wrapper>
  );
};

export default SuggestedArticleListItem;
